// removed by extract-text-webpack-plugin
module.exports = {"Base":"CategoryHero__Base-17cjm","Article":"CategoryHero__Article-2dgIx","Article--noImage":"CategoryHero__Article--noImage-11McH CategoryHero__Article-2dgIx","Figure":"CategoryHero__Figure-20aWY","FigureLink":"CategoryHero__FigureLink-39UJJ","Image":"CategoryHero__Image-ldOGJ","Base--horizontal":"CategoryHero__Base--horizontal-1AHQX","ContentArea":"CategoryHero__ContentArea-3DTIi","Header":"CategoryHero__Header-2md7a","Title":"CategoryHero__Title-3BqFQ","Title--underlined":"CategoryHero__Title--underlined-2RlbF CategoryHero__Title-3BqFQ","Content":"CategoryHero__Content-1eytz"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CategoryHero/CategoryHero.css
 ** module id = 624
 ** module chunks = 0
 **/